module.exports = __webpack_public_path__ + "media/images/navi_ioscor-loguito-c8c184ef92fb315aaa21ec99665b59ea.png";